import type { ModuleDefinition } from "../types";
import "./messages.nav";
import { REPORTS_BUILD, REPORTS_READ } from "./permissions";

const screens = () => import("./screens");

/** Analytics: the dashboard, the report library (canned and saved reports), and the report builder. */
export const reportsModule: ModuleDefinition = {
  id: "reports",
  labelKey: "module.reports",
  nav: [
    { id: "reports-dashboard", labelKey: "reports.nav.dashboard", to: "/reports", icon: "chart", permission: REPORTS_READ, end: true },
    { id: "reports-library", labelKey: "reports.nav.library", to: "/reports/library", icon: "log", permission: REPORTS_READ },
    { id: "reports-builder", labelKey: "reports.nav.builder", to: "/reports/builder", icon: "sliders", permission: REPORTS_BUILD },
  ],
  routes: [
    { path: "reports", permission: REPORTS_READ, load: async () => ({ default: (await screens()).DashboardPage }) },
    { path: "reports/library", permission: REPORTS_READ, load: async () => ({ default: (await screens()).LibraryPage }) },
    { path: "reports/canned/:key", permission: REPORTS_READ, load: async () => ({ default: (await screens()).CannedReportPage }) },
    { path: "reports/saved/:id", permission: REPORTS_READ, load: async () => ({ default: (await screens()).SavedReportPage }) },
    { path: "reports/builder", permission: REPORTS_BUILD, load: async () => ({ default: (await screens()).BuilderPage }) },
    { path: "reports/builder/:id", permission: REPORTS_BUILD, load: async () => ({ default: (await screens()).BuilderPage }) },
  ],
};
